'use client';
import styled, { css } from 'styled-components';

export const StyledImageDropdown = styled.div`
  position: relative;
  height: 108px;
  border-radius: ${props => props.theme.spacing(2)};
  background-color: ${props => props.theme.colors.background.lightest};
  display: flex;
  align-items: center;
  padding: ${props => props.theme.spacing(4, 4, 6)};

  @media ${props => props.theme.mobileS} {
    width: 361px;
  }

  @media ${props => props.theme.tablet} {
    width: 490px;
  }
`;

export const DropdownContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: ${props => props.theme.spacing(1)};
  flex: 1;
  min-width: 0;
  margin-right: ${props => props.theme.spacing(2)};
`;

export const SelectionRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing(2)};
`;

export const ContentHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: ${props => props.theme.spacing(1)};
`;

export const HeaderText = styled.p`
  color: ${props => props.theme.colors.text.primary};
  ${props => props.theme.typography.bodyBold}
`;

export const HelperText = styled.p`
  color: ${props => props.theme.colors.text.tertiary};
  ${props => props.theme.typography.body}
`;

export const SelectedText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${props => props.theme.colors.text.primary};
  ${props => props.theme.typography.button}
  max-width: 250px;
`;

export const DropdownButton = styled.div`
  cursor: pointer;
`;

export const IconContainer = styled.div``;

export const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: white;
  border-radius: ${props => props.theme.spacing(1)};
  padding-bottom: ${props => props.theme.spacing(6)};
  max-height: 400px;
  overflow-y: auto;
  margin-top: ${props => props.theme.spacing(-1.5)};
`;

export const StyledDropdownImageItem = styled.div`
  width: 100%;
  transition: background-color 0.2s ease;

  ${props =>
    props.$disabled &&
    !props.$isAllergen &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `}

  ${props =>
    props.$isAllergen &&
    css`
      pointer-events: none;

      & ${ContentImage} {
        opacity: 0.4;
        filter: grayscale(100%);
      }

      & ${ContentText} {
        opacity: 0.5;
        color: ${props.theme.colors.text.tertiary};
      }
    `}

  &:hover {
    background-color: ${props =>
      !props.$disabled && props.theme.colors.background.lightest};
  }
`;

export const DropdownItemContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: ${props => props.theme.spacing(1)};
  padding: ${props => props.theme.spacing(2, 4, 2)};
  cursor: pointer;
`;

export const ContentImage = styled.div`
  width: 75px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  transition: opacity 0.2s ease, filter 0.2s ease;
`;

export const ContentTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  min-width: 0;
`;

export const ContentText = styled.div`
  color: ${props => props.theme.colors.text.primary};
  ${props => props.theme.typography.button}
  transition: opacity 0.2s ease, color 0.2s ease;
`;

export const ContentLink = styled.div`
  ${props => props.theme.typography.body}
  color: ${({ theme }) => theme.colors.hero.plum};
  margin-top: ${props => props.theme.spacing(0.5)};
  display: flex;
  align-items: center;
`;

export const RedDot = styled.span`
  display: inline-block;
  width: ${props => props.theme.spacing(1.5)};
  height: ${props => props.theme.spacing(1.5)};
  background-color: ${props => props.theme.colors.status.errorPrimary};
  border-radius: 50%;
  margin-right: ${props => props.theme.spacing(1)};
  flex-shrink: 0;
`;

export const AllergyWarningText = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.theme.colors.text.secondary};
  ${props => props.theme.typography.body};
`;

export const LimitWarningText = styled.div`
  color: ${props => props.theme.colors.text.tertiary};
  ${props => props.theme.typography.body};
`;
